export enum DateTimeFormat {
  AUCTION_COUNTDOWN_FORMAT = "d'd' hh'h' mm'm'",
  DATE_TIME_FORMAT = 'LLLL dd yyyy, h:mm a',
  DATE_YEAR_FORMAT = 'LLL dd, yyyy',
  DAY_DATE_YEAR_FORMAT = 'EEE, LLL dd, yyyy',
  DEFAULT_TIME_ZONE = 'UTC',
  HOUR_24_TIME_FORMAT = 'HH:mm:ss',
  HOUR_FORMAT = 'hh',
  HOUR_MINUTE_SEPARATOR = ':',
  MERIDIEM_FORMAT = 'a',
  MINUTE_FORMAT = 'mm',
  MONTH_YEAR_FORMAT = 'MMMM yyyy',
  TIME_FORMAT = 'h:mm a',
  TIME_STAMP_FORMAT = 'hh:mm a',
  TIME_TYPE_FORMAT = 'yyyy-LL-dd hh:mm a',
  YEAR_MONTH_DAY_DASH_FORMAT = 'yyyy-LL-dd',
  YEAR_MONTH_DAY_SLASH_FORMAT = 'yyyy/LL/dd',
  YEAR_MONTH_DAY_UNDERSCORE_FORMAT = 'yyyy_LL_dd',
}
